import { connect } from 'react-redux'
import DurationInfo from './DurationInfo'

export default connect()(DurationInfo)
